<template>
	<div class="filters">
		<div class="row mt-3">
			<template v-for="filter in filters">
				<div :key="'select-' + filter.name" class="mb-2" :class="filter.colClass" v-if="filter.display">
					<template v-if="filter.type === 'text' || filter.type === 'number' || filter.type === 'email'">
						<label for="">{{ filter.label }}</label>
						<input
							:type="filter.type"
							class="form-control"
							@change="setFilter()"
							:placeholder="filter.placeholder"
							v-model="filter.value"
						/>
					</template>
					<template v-if="filter.type === 'select'">
						<label for="">{{ filter.label }}</label>
						<select class="form-select" @change="setFilter()" v-model="filter.value">
							<option value="">{{ filter.placeholder }}</option>
							<template v-if="filter.optionValue">
								<template v-for="(option, index) in filter.options">
									<option :key="index" :value="option">{{ option }}</option>
								</template>
							</template>
							<template v-else>
								<template v-for="(option, index) in filter.options">
									<option :key="index" :value="option.id">{{ option.name }}</option>
								</template>
							</template>
						</select>
					</template>
					<template v-if="filter.type === 'multiselect'">
						<label for="">{{ filter.label }}</label>
						<multiselect
							@input="setFilter()"
							:searchable="true"
							:limit="2"
							v-model="filter.value"
							:options="filter.options"
							:multiple="true"
						></multiselect>
					</template>
					<template v-if="filter.type === 'range'">
						<label for="">{{ filter.label }}</label>
						<div class="row">
							<div class="col-6">
								<input
									@input="setFilter()"
									type="number"
									:min="filter.min"
									:max="filter.max"
									class="form-control"
									:placeholder="'from ' + filter.placeholder"
									v-model="filter.from"
								/>
							</div>
							<div class="col-6">
								<input
									@input="setFilter()"
									type="number"
									:min="filter.min"
									:max="filter.max"
									class="form-control"
									:placeholder="'to ' + filter.placeholder"
									v-model="filter.to"
								/>
							</div>
						</div>
					</template>
					<template v-if="filter.type === 'daterange'">
						<label for="">{{ filter.label }}</label>
						<div class="row">
							<div class="col-6">
								<input
									@input="setFilter()"
									type="date"
									:min="filter.min"
									:max="filter.max"
									class="form-control"
									:placeholder="'from ' + filter.placeholder"
									v-model="filter.from"
								/>
							</div>
							<div class="col-6">
								<input
									@input="setFilter()"
									type="date"
									:min="filter.min"
									:max="filter.max"
									class="form-control"
									:placeholder="'to ' + filter.placeholder"
									v-model="filter.to"
								/>
							</div>
						</div>
					</template>
					<template v-if="filter.type === 'boolean'">
						<label for="">{{ filter.label }}</label>
						<select class="form-select" @change="setFilter()" v-model="filter.value">
							<option value="">{{ filter.placeholder }}</option>
							<template v-if="filter.optionValue">
								<template v-for="(option, index) in filter.options">
									<option :key="index" :value="option.value">{{ option.value }}</option>
								</template>
							</template>
							<template v-else>
								<template v-for="(option, index) in filter.options">
									<option :key="index" :value="option.id">{{ option.name }}</option>
								</template>
							</template>
						</select>
					</template>
				</div>
			</template>
			<div class="col-3" v-if="false">
				<button class="btn btn-primary mt-4">Advanced filters</button>
			</div>
		</div>
	</div>
</template>

<script>
import restApi from '../../api'
export default {
	name: 'LPDataTableFilters',
	props: ['filters'],
	data() {
		return {}
	},
	created() {
		this.getOptionsDataForFilters()
	},
	methods: {
		setFilter() {
			this.$emit('getFilters', { filters: this.filters })
		},

		// Load options for filters
		getOptionsDataForFilters() {
			this.filters.forEach(filter => {
				if (filter.optionsEndpoint && filter.optionsEndpoint !== '') {
					restApi.get(filter.optionsEndpoint).then(({ data }) => {
						filter.options = data
					})
				}
			})
		},
	},
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.multiselect__tag {
	padding: 5px 20px 5px 5px !important;
	margin-top: 0px !important;
	margin-bottom: 0px;
	max-height: 23px;
	min-height: 23px;
}

.multiselect__tags {
	display: block;
	width: 100%;
	padding: 0.375rem 0.75rem;
	font-size: 0.8rem;
	font-weight: 400;
	line-height: 1.6;
	color: #212529;
	background-color: #f8fafc;
	background-clip: padding-box;
	border: 1px solid #ced4da;
	-webkit-appearance: none;
	-moz-appearance: none;
	appearance: none;
	border-radius: 0.5rem;
	transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
	box-shadow: inset 0 -1px 0 #ddd;
	transition: box-shadow 0.2s;
	min-height: 23px;
}

.multiselect__placeholder {
	color: #adadad;
	display: inline-block;
	margin-bottom: 0px;
	padding-top: 2px;
}

.multiselect__tags-wrap {
	display: inline;
}
</style>
